import React, { useState } from "react";

import {
    Container,
    Row,
    Col,
    Nav,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

//About Images
import testImg01 from "../../../assets/images/about/img-02.jpg";
import testImg02 from "../../../assets/images/about/img-03.jpg";
import testImg03 from "../../../assets/images/about/img-04.jpg";
import testImg04 from "../../../assets/images/about/img-05.jpg";

const CompanyTestimonal = () => {
    const [activeTab, setActiveTab] = useState("1");

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row className="align-items-center g-5">
                        <Col lg={6}>
                            <div className="section-title mb-5 mb-lg-0">
                                <h4 className="title mb-4">A Human-Centered Approach to Talent</h4>
                                <strong>We are relationship builders.</strong>
                                <p className="text-muted mt-3">
                                    Matrix takes the time to understand your business philosophy, operating environment, and
                                    company culture. Every candidate we present is carefully evaluated not only for skill and
                                    experience but for how well they will integrate with your team and contribute to your goals.
                                </p>
                                <p className="text-muted">
                                    Our process—whether contingency or retained—is conducted with the highest level of
                                    confidentiality, integrity, and respect. Our clients and candidates are treated with the dignity they
                                    deserve, every step of the way.
                                </p>
                                <p className="text-muted">Whether it’s an executive hire or an hourly role, we focus on quality, fit, and integrity. We treat
                                    every search with discretion and every person with respect.</p>
                                <p className="text-muted">We are proud to be headquartered in Cincinnati, Ohio, and serve partners and professionals
                                    nationwide.</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <Row>
                                <Col md={3}>
                                    <Nav
                                        tabs
                                        className="about-testimonial-menu nav flex-sm-column flex-row nav-pills me-3"
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === "1" })}
                                            onClick={() => {
                                                toggle("1");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg01} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink
                                            className={classnames({ active: activeTab === "2" })}
                                            onClick={() => {
                                                toggle("2");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg02} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink
                                            className={classnames({ active: activeTab === "3" })}
                                            onClick={() => {
                                                toggle("3");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg03} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink
                                            className={classnames({ active: activeTab === "2" })}
                                            onClick={() => {
                                                toggle("4");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg04} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </Nav>
                                </Col>

                                <Col md={9}>
                                    <TabContent
                                        className="about-tab-content h-100"
                                        activeTab={activeTab}
                                    >
                                        <TabPane
                                            tabId="1"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg01})` }}
                                        ></TabPane>
                                        <TabPane
                                            tabId="2"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg02})` }}
                                        ></TabPane>
                                        <TabPane
                                            tabId="3"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg03})` }}
                                        ></TabPane>
                                        <TabPane
                                            tabId="4"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg04})` }}
                                        ></TabPane>
                                    </TabContent>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-5 g-5">
                        <Col lg={6}>
                            <div className="section-title mb-5 mb-lg-0">
                                <h4 className="title mb-4">For Employers</h4>
                                <p className="text-muted mt-3">
                                    When you partner with Matrix, you&#39;re not just hiring a recruiter—you’re gaining a strategic ally.
                                    We deliver more than resumes: we bring you candidates who are qualified, engaged, and
                                    aligned with your goals. Our extensive network and industry insight help ensure you hire right
                                    the first time.
                                </p>
                                <div className="d-flex align-items-center justify-content-between mt-4">
                                    <div>
                                        <Link to="/contact-us" className="btn btn-outline-primary">
                                            Contact Us <i className="uil uil-angle-right-b ms-1"></i>
                                        </Link>
                                    </div>
                                    <ul className="list-inline about-social-menu mb-0">
                                        <li className="list-inline-item">
                                            <Link to="/" className="">
                                                <i className="uil uil-facebook-f"></i>
                                            </Link>
                                        </li>
                                        <li className="list-inline-item">
                                            <Link to="/" className="">
                                                <i className="uil uil-twitter"></i>
                                            </Link>
                                        </li>
                                        <li className="list-inline-item">
                                            <Link to="/" className="">
                                                <i className="uil uil-whatsapp"></i>
                                            </Link>
                                        </li>
                                        <li className="list-inline-item">
                                            <Link to="/" className="">
                                                <i className="uil uil-instagram"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="section-title mb-5 mb-lg-0">
                                <h4 className="title mb-4">For Job Seekers</h4>
                                <p className="text-muted mt-3">
                                    Whether you’re actively searching or simply open to the right opportunity, Matrix is here to help
                                    guide your journey. We specialize in the Corrugated Packaging, Paper Mills, and Food &amp;
                                    Beverage sectors, but our reach extends across multiple other industries as well. Our team
                                    connects professionals with roles that match their experience, values, and ambitions—often
                                    before those jobs are even posted.
                                </p>
                                <p className="text-muted mt-3">
                                    We are committed to helping you take the next step in your career—with confidence, support,
                                    and expert insight.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default CompanyTestimonal;
